<template>
  <!--图片模型-->
  <div class="image-box" v-if="info">
    <div class="image-info-box" v-show="info && info.properties && info.type && info.type === 'info'">
      <img :src="info.properties.pic" alt="">
    </div>
    <div id="threeDmodel-box" class="image-info-box" v-show="info && info.properties  && info.type && info.type === 'threeDModel'">
      <!-- <img :src="info.properties.pic" alt=""> -->
    </div>
    <div id="threeDmodel-box-disk" class="image-info-box" v-show="showDisk && info && info.properties  && info.type && info.type === 'threeDModel'" @click="showDisk = false">
      <div>
        <img src="../../assets/img/pc/gesture.png" alt="">
        <p>手势滑动查看三维模型</p>
      </div>
    </div>

    <!--信息栏-->
    <div class="content-area">
      <div class="card-back">
        <div class="card">
          <h2 v-if="info">{{info.name}}</h2>
          <p v-if="info && info.properties" v-html="info.properties.content"></p>
        </div>
      </div>
    </div>

    <!--返回和浏览量-->
    <transition name="moveIn">
      <div class="logo-box">
        <div class="clearfix">
          <div class="back" @click="close"></div>
          <span></span>
          <p class="name">{{info.name}}</p>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'imagePage',
  components: {
  },
  props: {
    APPID: String,
    info: null,
    appInfo: Object,
    visitNum: Number,
    likeNum: Number,
    mainAudioPlay: Boolean,
    isLike: Boolean,
    isShowShare: Boolean,
    show: Boolean
  },
  data () {
    return {
      showDisk: true,
      model3dView: null,
      pluginInfo: {
        title: '',
        content: ''
      }
    }
  },
  mounted () {
  },
  watch: {
    info: {
      handler (newValue, oldValue) {
        if ((oldValue && oldValue.id !== newValue.id) || (!oldValue && newValue)) {
          setTimeout(() => {
            this.initThreeModel()
          }, 100)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 初始化三维
    initThreeModel () {
      if (!this.info || this.info.type !== 'threeDModel') {
        return
      }
      let modelInfo = JSON.parse(JSON.stringify(this.info.properties.modelInfo))
      let that = this
      if (!that.model3dView) {
        let container = document.getElementById('threeDmodel-box')
        that.model3dView = new vizengine.Model3DView(container)
        // console.log(that.model3dView.setModleIdAndJobId)
        that.setModelIdAndJobId(modelInfo, modelInfo.pose)
        return that.model3dView
      } else {
        that.setModelIdAndJobId(modelInfo, modelInfo.pose)
      }
    },
    setModelIdAndJobId (modelInfo, pose) {
      this.util.modelSetModelId(this.model3dView, modelInfo, () => {
        this.model3dView.setAlpha(0)
        this.model3dView.setLevelCount(2)
        // console.log(pose)
        if (pose) {
          if (pose.pivotVersion) {
            this.model3dView.reloadPivotInfo(pose)
            this.modelPose = pose
          } else {
            let data = {
              pivotVersion: 0,
              pose: pose
            }
            this.model3dView.reloadPivotInfo(data)
            this.modelPose = data
          }
        } else {
          if (modelInfo.pose) {
            let pos = JSON.parse(modelInfo.pose)
            if (pos.pivotVersion) {
              this.modelPose = pos
            } else {
              this.modelPose = {
                pivotVersion: 0,
                pose: pos
              }
            }
          } else {
            let that = this
            this.modelPose = {
              pivotVersion: 1,
              pose: {
                defaultDistanceRate: that.model3dView.modelConfig.defaultDistanceRate,
                defaultHeading: that.model3dView.getHeading(),
                defaultPitch: that.model3dView.getPitch(),
                lookAnchor: that.model3dView.getLookAnchor(),
                lookatLocation: that.model3dView.getLookatLocation(),
                matrix: that.model3dView.modelConfig.matrix.elements
              }
            }
          }
          console.log(this.modelPose)
        }
      })
    },
    close () {
      this.$emit('close', false)
    }
  }
}
</script>

<style lang="scss">
  @function rem($px) {
    @return $px*(1/40)*1rem;
  }
  $animationTime: 0.6s;

  .image-box{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    // background: url("../../assets/img/pc/image-page-background.png") no-repeat 0 0;
    background-image: linear-gradient(179deg, #0A4A6D 0%, #5E6D75 46%, rgba(138,166,181,0.82) 70%, #5E6D75 81%, #0A4A6D 100%);
    background-size: 100% 100%;
    z-index: 9;
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .image-info-box{
      width: rem(750);
      position: absolute;
      left: 50%;
      top: rem(200);
      margin-left: rem(-375);
      font-size: 0;
      img{
        width: rem(750);
      }
    }
    #threeDmodel-box {
      width: 100%;
      height: 100vh;
      margin: 0;
      left: 0;
      top: 0;
    }
    #threeDmodel-box-disk {
      width: 100%;
      margin: 0;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      position: fixed;
      background: rgba(0, 0, 0, 0.4);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999;
      div {
        text-align: center;
      }
      img {
        display: block;
        width: rem(57);
        margin: auto;
      }
      p {
        margin-top: rem(5);
        font-size: 12px;
        color: #FFFFFF;
        letter-spacing: 1px;
        text-align: justify;
      }
    }

    .content-area{
      position: absolute;
      right: rem(48);
      top: rem(50);
      .card-back{
        margin-left: rem(10);
        width: rem(457);
        border-top: rem(2) solid #FCD187;
        border-bottom: rem(2) solid #FCD187;
      }
      .card{
        margin-left: rem(2);
        margin-right: rem(2);
        padding: rem(15) rem(20) rem(15) rem(29);
        // background: linear-gradient(to left, #FB8D5F 0%, #E35343 34%, #CD3429 58%, #990A01 100%);
        background: url('../../assets/img/pc/img-background.png');
        background-size: cover;
      }
      h2{
        font-family: SemiBold;
        font-size: rem(24);
        color: #fff;
        letter-spacing: rem(2);
        line-height: rem(34);
        margin-bottom: rem(8);
      }
      p{
        font-size: rem(16);
        color: #FFFFFF;
        letter-spacing: rem(1);
        line-height: rem(24);
        text-align: justify;
        text-indent: rem(24);
      }
    }

    .loading-box{
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 75%;

      .loading-icon-back{
        width: rem(100);
        height: rem(100);
        background: url("../../assets/img/mobile/loading-back.png") no-repeat center center;
        background-size: rem(100) rem(100);
        position: absolute;
        left: 50%;
        top: 60%;
        margin-left: rem(-50);
        margin-top: rem(-50);

        .loading-icon{
          width: rem(50);
          height: rem(50);
          background: url("../../assets/img/mobile/loading.png") no-repeat center center;
          background-size: rem(50) rem(50);
          position: absolute;
          left: 50%;
          top: 50%;
          margin-left: rem(-25);
          margin-top: rem(-25);
          -webkit-animation: loadingmove 1s forwards steps(10) infinite;
          animation: loadingmove 1s forwards steps(10) infinite;
        }

        @-webkit-keyframes loadingmove {
          0% { -webkit-transform: rotateZ(0); }
          100% { -webkit-transform: rotateZ(360deg); }
        }

        @keyframes loadingmove {
          0% { transform: rotateZ(0); }
          100% { transform: rotateZ(360deg); }
        }
      }
    }

    .model-funcKey-box {
      width: rem(25);
      height: rem(25);
      position: absolute;
      right: rem(14);
      top: rem(150);
      &.moveIn-enter, &.moveIn-leave-to {
        transform: translateX(rem(40));
      }
      &.moveIn-enter-active, &.moveIn-leave-active {
        transition: transform $animationTime;
      }
      .btn-show-area{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: rem(37 * 4);
        margin-top: rem(25);
        overflow: hidden;
        &.all{
          height: rem(37 * 8);
        }
        &.vr{
          margin-top: 0;
        }
        &.opacity-enter, &.opacity-leave-to {
          opacity: 0;
        }
        &.opacity-enter-active, &.opacity-leave-active {
          transition: opacity $animationTime;
        }
      }
      .btn-box{
        width: 100%;
        li{
          width: 100%;
          height: rem(25);
          margin-top: rem(12);
          position: relative;
        }
        .music{
          background: url("../../assets/img/mobile/icon-music.png") no-repeat 0 0;
          background-size: rem(25) rem(25);
          &.on{
            background: url("../../assets/img/mobile/icon-music-color.png") no-repeat 0 0;
            background-size: rem(25) rem(25);
            animation: musicRotate 5s linear infinite;
          }
        }
        .gyroscope{
          background: url("../../assets/img/mobile/icon-gyroscope-off.png") no-repeat 0 0;
          background-size: rem(25) rem(25);
          &.on{
            background: url("../../assets/img/mobile/icon-gyroscope-on.png") no-repeat 0 0;
            background-size: rem(25) rem(25);
          }
        }
        .vr{
          background: url("../../assets/img/mobile/icon-vr-off.png") no-repeat 0 0;
          background-size: rem(25) rem(25);
          &.on{
            background: url("../../assets/img/mobile/icon-vr-on.png") no-repeat 0 0;
            background-size: rem(25) rem(25);
          }
        }
        .like{
          background: url("../../assets/img/mobile/icon-like.png") no-repeat 0 0;
          background-size: rem(25) rem(25);
          &.on{
            background: url("../../assets/img/mobile/icon-like-color.png") no-repeat 0 0;
            background-size: rem(25) rem(25);
          }
          .num{
            display: block;
            font-family: PingFangSC-Regular;
            font-size: rem(8);
            line-height: rem(14);
            color: #FFFFFF;
            text-align: center;
            text-shadow: 0 1px 1px rgba(70,69,69,0.50);
            position: absolute;
            top: rem(-12);
            left: 50%;
            transform: translateX(-50%);
          }
        }
        .share{
          background: url("../../assets/img/mobile/icon-share.png") no-repeat 0 0;
          background-size: rem(25) rem(25);
          &.on{
            background: url("../../assets/img/mobile/icon-share-color.png") no-repeat 0 0;
            background-size: rem(25) rem(25);
          }
        }
        .roaming{
          background: url("../../assets/img/mobile/icon-roaming.png") no-repeat 0 0;
          background-size: rem(25) rem(25);
          &.on{
            background: url("../../assets/img/mobile/icon-roaming-color.png") no-repeat 0 0;
            background-size: rem(25) rem(25);
          }
        }
        .info{
          background: url("../../assets/img/mobile/icon-info.png") no-repeat 0 0;
          background-size: rem(25) rem(25);
          &.on{
            background: url("../../assets/img/mobile/icon-info-color.png") no-repeat 0 0;
            background-size: rem(25) rem(25);
          }
        }
        .comment{
          background: url("../../assets/img/mobile/icon-comment.png") no-repeat 0 0;
          background-size: rem(25) rem(25);
          &.on{
            background: url("../../assets/img/mobile/icon-comment-color.png") no-repeat 0 0;
            background-size: rem(25) rem(25);
          }
        }
      }
      .control-btn{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: rem(25);
        background: url("../../assets/img/mobile/icon-menu-btn.png") no-repeat 0 0;
        background-size: rem(25) rem(25);
        transition: transform $animationTime;
        &.up{
          transform: rotateZ(-180deg);
        }
      }
    }
  }
</style>
